import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { MirrorsListEditPayload } from '@modules/mirrors-list/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { MIRRORS_LIST_PERMISSIONS, MIRRORS_LIST_QUERY_KEY } from '@modules/mirrors-list/constants';
import {
  MIRRORS_LIST_EDIT_MUTATION_API_URL,
  MIRRORS_LIST_EDIT_MUTATION_KEY,
} from '@modules/mirrors-list/submodules/edit/constants';
import { useToastStore } from '@modules/toast/store';

export default function useMirrorsListEditMutation(): IContextMutationResult<void, Error, MirrorsListEditPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, MirrorsListEditPayload>({
    mutationKey: [MIRRORS_LIST_EDIT_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      MIRRORS_LIST_EDIT_MUTATION_API_URL,
      { mirror: payload },
      {
        permission: MIRRORS_LIST_PERMISSIONS.EDIT,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [MIRRORS_LIST_QUERY_KEY] });
      displayPresetToast('success');
    },
  });
}
